import React from "react"
import styled from "styled-components"
import { UserIcon } from "../../icons"
import { defaultThemeColors, fonts, mediaSizes } from "../../theme"
import { StarReview } from "../starReview/StarReview"

export const ReviewCard = ({
    img,
    name,
    subTitle,
    message,
    rate,
}) => {
    return (
        <ReviewCardContainer>
            <Container>
                <UserContainer>
                    <div>
                        {img ? (
                            <UserAvatar src={img} />
                        ) : (
                            <Avatar>
                                <UserIcon color='txt' />
                            </Avatar>
                        )}
                    </div>
                    <UserInfoContainer>
                        <div>
                            <UserName>{name}</UserName>
                            {subTitle ? <SubTitle>{subTitle}</SubTitle> : null}
                        </div>
                        <div>
                            <StarReview filledColor='#554DF1' rate={rate} size={18} />
                        </div>
                    </UserInfoContainer>
                </UserContainer>
                <SlideReviewText>{message}</SlideReviewText>
            </Container>
        </ReviewCardContainer>
    )
}

const ReviewCardContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: 0.8rem;
    border-radius: 8px;
    border-width: 2px;
    border-style: solid;
    border-color: ${defaultThemeColors.lightBlue};
    display: flex;

    @media (width >= ${mediaSizes.md}) {
        padding: 1.5rem;
    }

    @media (width >= ${mediaSizes.lg}) {
        padding: 2rem;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 19px;
    font-family: Montserrat;
`

const UserContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
         margin-top: 1rem;
    }
`

const Avatar = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: ${defaultThemeColors.buttonBgNeutral};
    border-radius: 99px;

    & > svg {
        height: 20px;
        width: 20px;
    }

    @media (width >= ${mediaSizes.md}) {
        width: 60px;
        height: 60px;
        & > svg {
            height: 30px;
            width: 30px;
        }
    }

    @media (width >= ${mediaSizes.lg}) {
        width: 80px;
        height: 80px;
        & > svg {
            height: 40px;
            width: 40px;
        }
    }
`

const UserAvatar = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 99px;
    overflow: hidden;
    object-fit: cover;
    @media (width >= ${mediaSizes.md}) {
        width: 60px;
        height: 60px;
    }
    @media (width >= ${mediaSizes.lg}) {
        width: 80px;
        height: 80px;
    }
`

const UserInfoContainer = styled.div`
    display: grid;
    gap: 5px;
    @media (width >= ${mediaSizes.lg}) {
        gap: 10px;
    }

`

const UserName = styled.p`
    font-weight: 600;
    font-size: ${fonts.sizes.regular};
    color: ${defaultThemeColors.txt};
`

const SubTitle = styled.p`
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-transform: uppercase;
    color: ${defaultThemeColors.txt};
    opacity: 0.5;
`

const SlideReviewText = styled.div`
    font-family: var(--font-secondary);
    font-weight: 400;
    font-size: ${fonts.sizes.regular};
    color: ${defaultThemeColors.black};

`
